import { Router, ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { SpaEventService } from '../../Services/spaEvents.service';
import { LicenceHolderService } from '@services/licence_holder.service';
import { sharedResolution } from '../../../../src/shared_resolution';

@Component({ standalone: false, template: ` <div>...</div> ` })
export class ProxyRedirectComponent {
	constructor(router: Router, route: ActivatedRoute, spaEventService: SpaEventService) {
		const token = route.snapshot.queryParams['token'];
		const licenceHolderService = sharedResolution.resolve(LicenceHolderService);

		if (token) {
			router.navigate([licenceHolderService.alias]);

			spaEventService.onRegistrationRequired.emit({
				target: licenceHolderService.alias,
				ticket: token,
			});

			return;
		}

		router.navigate([licenceHolderService.alias]);
	}
}
